import { stringToSVG } from '../../../utilities';

const svg = `<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_code_file)">
<path d="M27.5 5V10H32.5" stroke="black" stroke-width="1.5"/>
<path d="M32.5 10L27.5 5H7.5V35H32.5V10Z" stroke="#2E3138" stroke-width="1.5"/>
<path d="M16.5 17L11.5 22L16.5 27" stroke="#2E3138" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M23.5 17L28.5 22L23.5 27" stroke="#2E3138" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M22 15L18 29" stroke="#2E3138" stroke-width="1.5" stroke-linecap="round"/>
</g>
<defs>
<clipPath id="clip0_code_file">
<rect width="40" height="40" fill="white"/>
</clipPath>
</defs>
</svg>`;

export default stringToSVG(svg);
